import React from "react";
import { Modal } from "react-bootstrap";

import { Button } from "components";
import CloseButton from "components/closeButton";
import { SSNNormalizer } from "validators";

import styles from "./modal.module.scss";

type MerchantModalProps = {
	show: boolean;
	onHide: () => void;
	owner: { [key: string]: any };
	handleShowViewFullAppDocument: Function;
};

const MerchantModal = ({
	show,
	onHide,
	owner,
	handleShowViewFullAppDocument,
}: MerchantModalProps) => {
	return (
		<Modal
			show={show}
			onHide={onHide}
			animation={false}
			className={styles.wrappModal}
			backdrop={false}
			onShow={() => {
				document.getElementsByTagName("body")[0].style.overflow =
					"auto";
			}}
		>
			<Modal.Header className={styles.wrappModalHeader}>
				<CloseButton onClick={onHide} />
			</Modal.Header>
			<Modal.Body className={styles.wrappModalHeader}>
				<div className={styles.content}>
					<div className={styles.row}>
						<p className={styles.title}>Name</p>
						<p className={styles.desc}>{owner.fullName}</p>
					</div>
					<div className={styles.row}>
						<p className={styles.title}>Address</p>
						<p className={styles.desc}>{owner.address}</p>
					</div>
					<div className={styles.row}>
						<p className={styles.title}>SSN</p>
						<p className={styles.desc}>
							{SSNNormalizer(owner.partialSSN)}
						</p>
					</div>
				</div>
				<div className={styles.wrapBtn}>
					<Button
						onClick={handleShowViewFullAppDocument}
						value="View full app"
					/>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default MerchantModal;
